import React, { useEffect, useState } from 'react'
import { Bell } from 'lucide-react'
import { Card, CardContent } from '../ui/card'
import { Button } from '../ui/button'
import { getAvisosPendientes, marcarAvisoLeido } from '../../lib/services/avisos'

// Avisos de la plataforma para el Owner de la org activa (hoy: cambios de deportes).
// El Platform Admin tambien puede LEERLOS por RLS, pero solo el Owner puede marcarlos:
// por eso se pinta solo si quien mira es el Owner.
const AvisosOwner = ({ orgId, esOwner }) => {
  const [avisos, setAvisos] = useState([])
  const [marcando, setMarcando] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!esOwner || !orgId) { setAvisos([]); return }
    let vivo = true
    getAvisosPendientes(orgId).then(({ data }) => { if (vivo) setAvisos(data || []) })
    return () => { vivo = false }
  }, [orgId, esOwner])

  if (!esOwner || avisos.length === 0) return null

  const entendido = async (id) => {
    setMarcando(id)
    setError(null)
    const { error: err } = await marcarAvisoLeido(id)
    setMarcando(null)
    if (err) {
      setError('No se pudo marcar el aviso. Intenta de nuevo.')
      return
    }
    setAvisos((prev) => prev.filter((a) => a.id !== id))
  }

  return (
    <div className="space-y-3">
      {avisos.map((a) => (
        <Card key={a.id} className="border-primary/40">
          <CardContent className="flex flex-col gap-3 py-4 sm:flex-row sm:items-start">
            <Bell className="h-5 w-5 shrink-0 text-primary" />
            <div className="min-w-0 flex-1">
              <p className="font-semibold">{a.titulo}</p>
              <p className="mt-1 text-sm text-muted-foreground">{a.cuerpo}</p>
            </div>
            <Button size="sm" variant="outline" onClick={() => entendido(a.id)} disabled={marcando === a.id}>
              {marcando === a.id ? 'Guardando...' : 'Entendido'}
            </Button>
          </CardContent>
        </Card>
      ))}
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  )
}

export default AvisosOwner
